module.exports = __webpack_public_path__ + "static/media/1981.430fa213.jpg";